import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import { useCallback, useState } from 'react';
import UIList from 'UIComponents/list/UIList';
import { usageTracker } from '../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../usage-tracker/trackerChannelIdMapping';
import MessageActionsButton from './MessageActionsButton';
import I18n from 'I18n';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMessageActionButton = styled(MessageActionsButton).withConfig({
  displayName: "MessageActionsDropdown__StyledMessageActionButton",
  componentId: "sc-10kxx63-0"
})(["margin-left:4px;"]);
const MessageActionsDropdown = ({
  children,
  genericChannelId
}) => {
  // Manually manage the state of the UITooltip to close when the dropdown opens
  const [openTooltip, setOpenTooltip] = useState(undefined);
  const onDropdownOpenChange = dropdownOpenChangeEvent => {
    if (dropdownOpenChangeEvent.target.value) {
      setOpenTooltip(false);
    } else {
      // Set openTooltip back to undefined instead of true because undefined gives control back to the UITooltip
      setOpenTooltip(undefined);
    }
  };
  const trackOpen = () => {
    usageTracker.track('view-message-actions', {
      action: 'view message actions',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  const renderDropdownButton = useCallback(({
    onClick
  }) => {
    return /*#__PURE__*/_jsx(StyledMessageActionButton, {
      onClick: onClick,
      buttonIcon: 'verticalMenu',
      tooltipProps: {
        title: I18n.text('conversations-inbox-message-history.common-message.messageActions'),
        open: openTooltip
      }
    });
  }, [openTooltip]);
  return /*#__PURE__*/_jsx(UIDropdown, {
    Button: renderDropdownButton,
    minMenuWidth: 125,
    caretRenderer: null,
    iconName: 'verticalMenu',
    placement: 'bottom left',
    arrowSize: 'none',
    animateOnToggle: true,
    "data-test-id": "message-actions-dropdown",
    onOpenChange: onDropdownOpenChange,
    onOpenComplete: trackOpen,
    role: 'menu',
    children: /*#__PURE__*/_jsx(UIList, {
      children: children
    })
  });
};
MessageActionsDropdown.displayName = 'MessageActionsDropdown';
export default MessageActionsDropdown;